import { SaiQuickTourFormCoachStep } from 'app/ui/sai-quick-tour/sai-quick-tour-form-coach.types';

/** Guided walkthrough inside Add Agent while the main tour is on that step. */
export const SAI_QUICK_TOUR_AGENT_FORM_COACH_STEPS: readonly SaiQuickTourFormCoachStep[] = [
    {
        id: 'agent-intro',
        titleKey: 'Tour · Meet the Add Agent form',
        bodyKey:
            'We prefilled a demo agent. Walk through name, data source, and instructions — then save when you are ready.',
    },
    {
        id: 'agent-name',
        titleKey: 'Tour · Agent Name',
        bodyKey:
            'A clear name shows up in chat, sharing, and reports. Demo value: “Demo Sales Agent”.',
        fieldTourId: 'agent-field-name',
        sampleKey: 'Demo Sales Agent',
    },
    {
        id: 'agent-data-source',
        titleKey: 'Tour · Data Source',
        bodyKey:
            'Link the agent to one or more data sources so it can answer from your tables and documents.',
        fieldTourId: 'agent-field-data-source',
    },
    {
        id: 'agent-instructions',
        titleKey: 'Tour · Custom Instructions',
        bodyKey:
            'Tell the agent how to behave — tone, topics, and what to prioritize. We added a short demo prompt.',
        fieldTourId: 'agent-field-instruction',
    },
    {
        id: 'agent-save',
        titleKey: 'Tour · Save your agent',
        bodyKey:
            'Click Add to create the agent — next open SAI Chat and ask it a question.',
        fieldTourId: 'agent-field-submit',
    },
];
